export const hasAllNullOrUndefinedValues = (obj: any): boolean =>
  !obj || Object.keys(obj).every(key => typeof obj[key] === 'undefined' || obj[key] === null);

export const propertyExists = (property: any): boolean => {
  return typeof property !== 'undefined';
};
